import * as yup from "yup";

export const emailSchema = yup.object({
  sender: yup.string().required("Sender is required"),
  recipient: yup.string().required("Recipient is required"),
  cc: yup.string().email(),
  bcc: yup.string().email(),
  relatedToContact: yup.string(),
  relatedToLead: yup.string(),
  subject: yup.string(),
  message: yup.string(),
  startDate: yup.date().required("Start Date is required"),
  category: yup.string().required("Category is required"),
  createBy: yup
    .array()
    .of(yup.string().matches(/^[0-9a-fA-F]{24}$/, "Must be a valid ObjectId"))
    .when("recipient", {
      is: "Contact",
      then: (schema) =>
        schema.min(1, "At least one Contact is required").required(),
      otherwise: (schema) => schema,
    }),
  createByLead: yup
    .array()
    .of(yup.string().matches(/^[0-9a-fA-F]{24}$/, "Must be a valid ObjectId"))
    .when("recipient", {
      is: "Lead",
      then: (schema) =>
        schema.min(1, "At least one Lead is required").required(),
      otherwise: (schema) => schema,
    }),
});
